import { useEffect } from 'react';
import { useToggle } from '@sdk/common/hooks/useToggle';

import type { ShowPublishShiftTooltip } from '../onboardingChecklist.types';
import { SCHEDULE_PATH_NAME } from '../onboardingChecklist.consts';

type Props = { isLoaded: boolean; showPublishShiftTooltip: ShowPublishShiftTooltip };

const usePublishScheduleTooltip = ({ isLoaded, showPublishShiftTooltip }: Props) => {
  const {
    isOn: triggerPublishTooltipOn,
    setOn: setTriggerPublishTooltipOn,
    setOff: setTriggerPublishTooltipOff,
  } = useToggle(false);

  useEffect(() => {
    //we need to display tooltip on schedule tab after loading is finished, here we triggering tooltip by triggerPublishTooltipOn and isLoadded flags
    if (triggerPublishTooltipOn && !isLoaded && window.location.pathname === SCHEDULE_PATH_NAME) {
      showPublishShiftTooltip();
      setTriggerPublishTooltipOff();
    }
  }, [isLoaded, triggerPublishTooltipOn, setTriggerPublishTooltipOff, showPublishShiftTooltip]);

  return { setTriggerPublishTooltipOn, setTriggerPublishTooltipOff };
};

export default usePublishScheduleTooltip;
